import { render, staticRenderFns } from "./CommunicationBadge.vue?vue&type=template&id=a017f1a2"
import script from "./CommunicationBadge.vue?vue&type=script&lang=ts"
export * from "./CommunicationBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports